import { useEffect, ReactElement, useState } from 'react';
import { useRouter } from 'next/router';

import { FeatureFlags } from 'featureFlags/constants';
import { useFeatureFlag } from 'shared/hooks';
import { fireSnapchatPageView } from 'tracking/utils/snapchatEvents';

declare global {
  interface Window {
    snaptr: any;
    isSnapLoaded?: boolean;
  }
}

interface ISnapchatProviderProps {
  children: ReactElement;
}

export const SnapchatProvider = ({ children }: ISnapchatProviderProps) => {
  const router = useRouter();
  const isSnapchatEnabled = useFeatureFlag(FeatureFlags.WEB_ENABLE_SNAPCHAT);
  const [isFirstPageLoad, setIsFirstPageLoad] = useState(true);

  useEffect(() => {
    if (!isSnapchatEnabled) return;

    if (isFirstPageLoad && !!window?.snaptr) {
      void fireSnapchatPageView();

      setIsFirstPageLoad(false);
    }
  }, [isSnapchatEnabled, isFirstPageLoad]);

  useEffect(() => {
    if (!isSnapchatEnabled) return null;

    router.events.on('routeChangeComplete', fireSnapchatPageView);

    return () => {
      router.events.off('routeChangeComplete', fireSnapchatPageView);
    };
  }, [router.events, isSnapchatEnabled]);

  return children;
};
